import React from "react";
import { ReactSortable } from "react-sortablejs";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import Input from "../../../components/FormComponents/Input";
import Label from "../../../components/FormComponents/Label";
import useFetchData from "../../../hooks/useFetchData";
import Button from "../../../components/FormComponents/Button";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";

const FormButtonGroup = ({ value, onChange, tableID }) => {
  const { data, loading, error } = useFetchData(`/state-machine/${tableID}/states`);

  const addButton = (e) => {
    onChange(
      [...value, { label: "", color: "", value: "" }],
      {
        type: "add",
        index: value.length,
        data: {
          label: "",
          color: "",
          value: ""
        }
      },
      e
    );
  };

  const handleDataInput = (name, newvalue, index, e) => {
    const newObj = [...value];
    newObj[index][name] = newvalue;
    onChange(
      newObj,
      {
        type: "changevalue",
        index: index,
        data: {
          [name]: newvalue
        }
      },
      e
    );
  };

  const deleteOptionData = (index, e) => {
    const newObj = [...value];
    const removedData = newObj[index]; // Retrieve the object that will be removed
    newObj.splice(index, 1);
    onChange(
      newObj,
      {
        type: "remove",
        index: index,
        data: removedData // Include the removed object here
      },
      e
    );
  };

  const handleSetList = (values) => {
    onChange(values, {
      type: "reorder"
    });
  };

  if (loading) return <div>Loading....</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <>
      {value.length > 0 && (
        <div className="form_data_action_wrapper">
          <Label className="form_appuser_filter_tag">Add button group</Label>

          <ReactSortable
            list={value}
            setList={handleSetList}
            handle=".Recordsviewfielddragclass"
            animation="200"
            easing="ease-out"
            className="builder_form"
          >
            {value.map((singleButton, index) => (
              <>
                <div className={`flex_row gap_2 align_center`} key={index}>
                  <MaterialIcon name="drag_indicator" className="Recordsviewfielddragclass" />
                  <Input
                    name="label"
                    placeholder="Button Label"
                    value={singleButton.label}
                    onChange={(e) => handleDataInput(e.target.name, e.target.value, index, e)}
                  />
                  <SingleSelectBox
                    selectedData={singleButton.value}
                    options={data}
                    onChange={(obj, e) => handleDataInput("value", obj.id, index, e)}
                    placeholder="Target State"
                    containerClassName="m_0"
                  />
                  <Input
                    type="color"
                    name="color"
                    placeholder="Enter Color"
                    value={singleButton.color}
                    onChange={(e) => handleDataInput(e.target.name, e.target.value, index, e)}
                    containerClassName="w_auto"
                    // inputBoxStyle={{ height: "36px", padding: "4px" }}
                  />
                  <MaterialIcon
                    name="delete"
                    className="builder_action_btn delete"
                    onClick={(e) => deleteOptionData(index, e)}
                  />
                </div>
              </>
            ))}
          </ReactSortable>

          <div className="d_flex justify_end mt_2">
            <Button size="small" variant="secondary" onClick={addButton}>
              +
            </Button>
          </div>
        </div>
      )}
      {value.length === 0 && (
        <div className="w_100 d_flex align_center justify_between">
          <Label>Add buttons </Label>
          <Button variant="secondary" onClick={addButton}>
            + Add
          </Button>
        </div>
      )}
    </>
  );
};

export default FormButtonGroup;
